import type { InputType } from 'src/constants';

export const getInputProps = (
  type: InputType,
  isRequired: boolean = false,
  value: string = ''
) => ({
  value,
  isRequired,
  isValid: true,
  textError: '',
  type,
});
